import { createContext } from "react";

const GridExportContext = createContext<(() => void) | undefined>(undefined);

export default GridExportContext;
